<template>
<footer class="footer">
    <div class="principal visita">
    <a class="footer-action col" href="https://sumabeneficios.com/alta-comercios/">
        <span class="d-none d-sm-inline">Registrar negocio</span>
        <font-awesome-icon :icon="Icons.COMERCIO_SOLICITUD" />
    </a>
    <a class="brown-text text-lighten-3 col" href="index.html">
        <strong>BePros© {{ new Date().getFullYear() }} </strong>
    </a>
    <router-link class="footer-action col" to="/login">
        <span class="d-none d-sm-inline">Panel de Administración</span>
        <font-awesome-icon :icon="Icons.PANEL_ADMIN" />
    </router-link>
    </div>
</footer>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { Icons as IconConstants } from "../../../constants";

export default {
components:{
    FontAwesomeIcon,
},
computed:{
    /**Constantes de iconos */
    Icons() {
        return IconConstants;
    },
}
}
</script>
<style scoped>
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;

  background: var(--color-estructura-a);
  box-shadow: 0px -5px 5px 0px rgba(0, 0, 0, 0.75);
  z-index: 15;
  padding-left: 5%;
  padding-right: 5%;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  color: white;
}

.footer .principal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.principal{
  background: transparent;
}

.footer-action {
  display: flex;
  color: white;
  text-decoration: none;
  font-size: 15px;
  justify-content: center;
  align-items: center;
}

.footer-action:hover,
.footer-action svg:hover {
  color: var(--color-estructura-c);
  font-size: 13px;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.footer-action svg {
  margin-left: 5px;
  font-size: 19px;
}
</style>